const SOCIAL_PAGES = [
    {
        "name" : "facebook",
        "link" : "https://www.facebook.com/profile.php?id=100093037981971&mibextid=ibOpuV/",
        "imgUrl" : "images/social/facebook.png",
        "bw-social-imgUrl" : "images/social/bw/facebook.png",
    },
    {
        "name" : "instagram",
        "link" : "https://www.instagram.com/tenetix.ai/",
        "imgUrl" : "images/social/instagram.png",
        "bw-social-imgUrl" : "images/social/bw/instagram.png",
    },
    {
        "name" : "linkedin",
        "link" : "https://www.linkedin.com/company/tenetix/",
        "imgUrl" : "images/social/linkedin.png",
        "bw-social-imgUrl" : "images/social/bw/linkedin.png",
    }
]

export { SOCIAL_PAGES }